var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-treeview", {
    key: "treeview-" + _vm.treeviewKey,
    attrs: {
      items: _vm.computedItems,
      activatable: "",
      dense: "",
      hoverable: "",
      selectable: Boolean(_vm.selectedItems.length),
      "selected-color": "primary",
      "multiple-active": "",
      "selection-type": "independent",
      open: _vm.open,
      search: _vm.searchText,
      active: _vm.selectedItems,
      "return-object": "",
    },
    on: {
      "update:open": function ($event) {
        _vm.open = $event
      },
      "update:search": function ($event) {
        _vm.searchText = $event
      },
      "update:active": function ($event) {
        _vm.selectedItems = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "prepend",
        fn: function (ref) {
          var item = ref.item
          return [
            item._type === "folder"
              ? _c("v-icon", [_vm._v(" mdi-folder ")])
              : _c("v-icon", [_vm._v(" mdi-file-document-outline ")]),
          ]
        },
      },
      {
        key: "label",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "v-list-item",
              {
                staticClass: "pl-0",
                attrs: { dense: "" },
                on: {
                  dblclick: function ($event) {
                    return _vm.navigateTo(item)
                  },
                },
              },
              [
                _c(
                  "v-list-item-content",
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "v-list-item-title",
                          {
                            staticClass: "case-link",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.navigateTo(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        ),
                      ],
                      1
                    ),
                    item._type !== "folder"
                      ? [
                          _c("v-list-item-subtitle", [
                            _vm._v(_vm._s(item.notes)),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "text-caption" },
                            [
                              _vm._v(
                                "Last modified: " +
                                  _vm._s(_vm.formatDate(item.updated)) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "append",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "tr",
              [
                item._type === "case"
                  ? _vm._l(_vm.calculations, function (calculation) {
                      return _c(
                        "td",
                        {
                          key: "calc-" + item.id + "-" + calculation.type,
                          staticClass: "px-2 text-center job-indicator",
                        },
                        [
                          _c("JobIndicator", {
                            key: calculation.key,
                            attrs: {
                              status: _vm.getJobStatus(
                                item.id,
                                calculation.type
                              ),
                              progress: _vm.getJobProgress(
                                item.id,
                                calculation.type
                              ),
                              error: _vm.getJobError(item.id, calculation.type),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleClickJob(
                                  item.id,
                                  calculation.type
                                )
                              },
                            },
                          }),
                          _c("v-spacer"),
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: "",
                                disabled: !calculation.name,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "a",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "table-header-link text-caption",
                                              attrs: {
                                                href: calculation.wikiUrl,
                                                target: "_blank",
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(calculation.shortName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [_c("span", [_vm._v(_vm._s(calculation.name))])]
                          ),
                        ],
                        1
                      )
                    })
                  : _vm._e(),
                _c(
                  "td",
                  [
                    _c(
                      "MenuMore",
                      {
                        attrs: { "offset-y": "", left: "" },
                        on: {
                          open: function ($event) {
                            return _vm.selectItem(item)
                          },
                        },
                      },
                      [
                        !item.locked
                          ? _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              _vm._l(
                                _vm.menuMoreItems(item),
                                function (menuItem) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key:
                                        item.id +
                                        "-menu-" +
                                        item._type +
                                        "-" +
                                        menuItem.actionName,
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.$emit(
                                            item._type === "case"
                                              ? "case-menu-click"
                                              : "folder-menu-click",
                                            menuItem.actionName,
                                            item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(menuItem.icon)),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(menuItem.text)),
                                      ]),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        },
      },
    ]),
    model: {
      value: _vm.selectedItems,
      callback: function ($$v) {
        _vm.selectedItems = $$v
      },
      expression: "selectedItems",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }